import { Pipe, PipeTransform } from '@angular/core';
import * as IBAN from 'iban';

@Pipe({
    name: 'formatIban',
    standalone: false
})
export class FormatIbanPipe implements PipeTransform {
  transform(value: string): string {
    return IBAN.printFormat(value ?? '');
  }
}
